import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CtaBanner } from "./Home";
import { IMG, TEAM } from "../data/site";

const initials = (name) =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const Team = () => (
  <div data-testid="team-page">
    <PageHero eyebrow="OUR TEAM" title="Meet the people behind J&S" subtitle="Licensed, experienced and genuinely passionate about getting your comfort right." image={IMG.commercialTeam} crumbs={[{ label: "Team" }]} />
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={(i % 4) * 0.06}>
            <div data-testid="team-card" className="group bg-js-grey rounded-3xl p-8 border border-black/5 h-full hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(11,78,162,0.1)] transition-[transform,box-shadow] duration-400">
              <span className="grid place-items-center w-16 h-16 rounded-2xl bg-js-blue text-white font-display font-extrabold text-xl tracking-tight group-hover:bg-js-dark transition-colors duration-300">
                {initials(m.name)}
              </span>
              <h3 className="font-display font-bold text-lg mt-5">{m.name}</h3>
              <p className="text-js-blue text-sm font-semibold mt-0.5">{m.role}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
    <CtaBanner />
  </div>
);

export default Team;
